import { FC } from "react";
import { Link } from "react-router-dom";
import { EXTERNAL, PATHS } from "../../../paths";

export interface SidebarLink {
  label: string;
  href: string;
  internal?: boolean;
}

export const BROCHURES: SidebarLink[] = [
  {
    label: "Securitas İtfaiye Hizmetleri Broşürü",
    href: "/uploads/2021/06/Securitas-Itfaiye-Turkce-Brosur.pdf",
  },
  { label: "Kalite Yönetim Programı", href: PATHS.quality, internal: true },
];

export const LEGISLATION: SidebarLink[] = [
  { label: "Avrupa Anlaşması 1", href: "/uploads/2017/12/ADR1.pdf" },
  { label: "Avrupa Anlaşması 2", href: "/uploads/2017/12/ADR2.pdf" },
  {
    label: "Uçak Kaza Kırım Yangın Mücadele Yönergesi",
    href: "/uploads/2018/01/Ucak-Kaza-Kirim-Kurtarma-ve-Yanginla-Mucadale-Yonergesi-2016.pdf",
  },
  {
    label: "Deniz Yolu Taşıma Yönergesi",
    href: "/uploads/2017/12/TM-Denizyolu-Tasima-Yo%CC%88netmeligi.pdf",
  },
  {
    label: "Seveso II Direktifi",
    href: "/uploads/2017/12/Seveso2Direktifi.pdf",
  },
  {
    label: "NFPA: National Fire Protection Association Hakkındaki Yönetmelik",
    href: EXTERNAL.nfpa,
  },
];

export const FOOTER_LINKS: SidebarLink[] = [
  ...BROCHURES.slice(0, 1),
  {
    label: "Fire & Safety Services (EN)",
    href: "/uploads/2021/06/Securitas-Itfaiye-Ingilizce-Brosur.pdf",
  },
  BROCHURES[1],
  {
    label: "ISO 9001, 14001 ve 45001",
    href: "/uploads/2024/securitas-itfaiye-ISO-9001-ISO-14001-ISO-45001.pdf",
  },
  {
    label: "Kişisel Verilerin Korunması",
    href: "/uploads/2020/09/SECURITAS-TURKIYE-Kisisel-Verilerin-Korunmasi-ve-Islenmesi-Politikasi-1.pdf",
  },
];

export const renderSidebarLink = ({ label, href, internal }: SidebarLink) => (
  <li key={label}>
    {internal ? (
      <Link to={href}>{label}</Link>
    ) : (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    )}
  </li>
);

const LinkSidebar: FC = () => (
  <aside className="it-sidebar">
    <div className="it-sbox">
      <h5>Broşürler</h5>
      <ul>{BROCHURES.map(renderSidebarLink)}</ul>
    </div>
    <div className="it-sbox">
      <h5>Yangın Mevzuatı</h5>
      <ul>{LEGISLATION.map(renderSidebarLink)}</ul>
    </div>
  </aside>
);

export default LinkSidebar;
